import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import ProductBoxBig from '@/components/Blue/Cart/ProductBoxBig.vue';
import FormattedPrice from '@/components/Base/Formats/FormattedPrice.vue';
import OpenPopupButton from '@/components/PopUps/OpenPopupButton.vue';
export default defineComponent({
    name: 'CartDisplay',
    data: function () {
        return {
            togglePopupGarantie: false,
        };
    },
    components: {
        OpenPopupButton,
        FormattedPrice,
        ProductBoxBig,
    },
    computed: Object.assign(Object.assign(Object.assign({}, mapGetters('blue', {
        current_products: 'currentProducts',
        product_total: 'brutto_products',
        isCartFilled: 'isCartFilled',
        currentShippingIdentifier: 'currentShippingIdentifier',
    })), mapGetters('account', {
        isLogin: 'isLogin',
    })), { total() {
            return this.product_total;
        },
        hasWarrantyForAll() {
            let hasWarranty = true;
            if (this.current_products.length === 0) {
                return false;
            }
            this.current_products.forEach((product) => {
                hasWarranty = hasWarranty && product.has_extended_warranty_month === 36;
            });
            return hasWarranty;
        } }),
    mounted() {
        // patch up href for needs login handling
        document.querySelectorAll('.needs_login').forEach((element) => {
            element.setAttribute('href', window.location.href);
        });
    },
});
